import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { setGlobalCounter } from '../actions/counter';
export default handleActions({
    [`${setGlobalCounter}`]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            conversations: action.payload.count
        })
}, {
    conversations: 0
});

//# sourceMappingURL=counter.js.map